import axios from "axios";

export default async function getDefaultDocument(projectName, formName, documentId) {
    const res = await axios.get(`/project/${projectName}/${formName}/Document/${documentId}/image`, { responseType: "blob" })
    return res;
}